import { render, staticRenderFns } from "./modal-task-sider.vue?vue&type=template&id=02ec3495&"
import script from "./modal-task-sider.vue?vue&type=script&lang=ts&"
export * from "./modal-task-sider.vue?vue&type=script&lang=ts&"
import style0 from "./modal-task-sider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports